"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_INFO = exports.ICON_INFO = exports.DEFAULT_VALUE = void 0;
var DEFAULT_VALUE = 0;
exports.DEFAULT_VALUE = DEFAULT_VALUE;
var ICON_INFO = {
  ICON: 'Person',
  SIZE: 'small',
  COLOR: 'secondaryDark'
};
exports.ICON_INFO = ICON_INFO;
var TEXT_INFO = {
  TYPE: 'small',
  COLOR: 'secondaryDark'
};
exports.TEXT_INFO = TEXT_INFO;